/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  REGIME_PLACEHOLDER,
  REGISTER_PLACEHOLDER,
} from '@assetaccountant/core/http-token.interceptor';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { GetFinancialYearSettingsQuery } from '../models/calendar/get-financial-year-settings.query';
import { GetFinancialYearSettingsResponse } from '../models/calendar/get-financial-year-settings.response';
import { GetPeriodsQuery } from '../models/calendar/get-periods.query';
import { GetPeriodsResponse } from '../models/calendar/get-periods.response';
import { GetYearsQuery } from '../models/calendar/get-years.query';
import { GetYearsResponse } from '../models/calendar/get-years.response';
import { SetFinancialYearSettingsCommand } from '../models/calendar/set-financial-year-settings.command';

@Injectable({
  providedIn: 'root',
})
export class CalendarV2Api {
  constructor(private http: HttpClient) {}

  getFinancialYearSettings(
    query: GetFinancialYearSettingsQuery = {},
  ): Observable<GetFinancialYearSettingsResponse> {
    return this.http.get<GetFinancialYearSettingsResponse>(
      `${environment.servicesApiUrl}/api/v2/calendar/${query.registerId ?? REGISTER_PLACEHOLDER}/regimes/${query.regimeId ?? REGIME_PLACEHOLDER}/fy-settings`,
    );
  }

  getPeriods(query: GetPeriodsQuery = {}): Observable<GetPeriodsResponse> {
    return this.http.get<GetPeriodsResponse>(
      `${environment.servicesApiUrl}/api/v2/calendar/${query.registerId ?? REGISTER_PLACEHOLDER}/regimes/${query.regimeId ?? REGIME_PLACEHOLDER}/periods`,
      {
        params: {
          ...(query.startDate ? { startDate: query.startDate } : {}),
          ...(query.endDate ? { endDate: query.endDate } : {}),
        },
      },
    );
  }

  getYears(query: GetYearsQuery = {}): Observable<GetYearsResponse> {
    return this.http.get<GetYearsResponse>(
      `${environment.servicesApiUrl}/api/v2/calendar/${query.registerId ?? REGISTER_PLACEHOLDER}/regimes/${query.regimeId ?? REGIME_PLACEHOLDER}/years`,
      {
        params: {
          ...(query.startDate ? { startDate: query.startDate } : {}),
          ...(query.endDate ? { endDate: query.endDate } : {}),
        },
      },
    );
  }

  setFinancialYearSettings(command: SetFinancialYearSettingsCommand): Observable<void> {
    return this.http.put<void>(
      `${environment.servicesApiUrl}/api/v2/calendar/${command.registerId ?? REGISTER_PLACEHOLDER}/regimes/${command.regimeId ?? REGIME_PLACEHOLDER}/fy-settings`,
      command,
    );
  }
}
